module.exports = __webpack_public_path__ + "static/search-1c208e982e631e31b8ee44abb0eed23e.gif";